/* eslint-disable no-unused-vars */
import apiClient from '@u/apiClient'
import GetCheckStatusController from '@/wayfinder/actions/App/Http/Controllers/CheckDeposit/GetCheckStatusController'
import GetCheckDepositByIdController from '@/wayfinder/actions/App/Http/Controllers/CheckDeposit/GetCheckDepositByIdController'
import GetCheckDepositListController from '@/wayfinder/actions/App/Http/Controllers/CheckDeposit/GetCheckDepositListController'
import GetCheckByStatusListController from '@/wayfinder/actions/App/Http/Controllers/CheckDeposit/GetCheckByStatusListController'
import StoreCheckDepositController from '@/wayfinder/actions/App/Http/Controllers/CheckDeposit/StoreCheckDepositController'
import UpdateCheckDepositController from '@/wayfinder/actions/App/Http/Controllers/CheckDeposit/UpdateCheckDepositController'
import DeleteCheckDepositController from '@/wayfinder/actions/App/Http/Controllers/CheckDeposit/DeleteCheckDepositController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  fetchCheckStatus({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetCheckStatusController.get())
        .then((response) => {
          commit('setCheckDataStatus', response.data)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewCheckDeposit({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'CheckDeposit' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchCheckDepositById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetCheckDepositByIdController.get({
            check_deposit: payload.check_deposit
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchCheckDepositList({ commit }) {
    await apiClient
      .route(GetCheckDepositListController.get())
      .then(async (response) => {
        await commit('setCheckDepositList', response.data.check_deposits)
        await commit('setCheckMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchChecksList', reason)
      })
  },

  fetchCheckByStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetCheckByStatusListController.get(), { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region store
  storeCheckDeposit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(StoreCheckDepositController.post(), payload.check_deposit)
        .then((response) => {
          resolve(response?.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  async updateCheckDeposit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateCheckDepositController.put({ check_deposit: payload.id }),
          payload.check_deposit
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  //region delete
  async deleteCheckDeposit({ commit }, payload) {
    await apiClient
      .route(
        DeleteCheckDepositController.delete.delete({
          check_deposit: payload.id
        })
      )
      .then(async (response) => {
        await commit('setCheckDepositList', response.data.check_deposits)
        await commit('setCheckMetadata', response.data.metadata)
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error(reason)
      })
  },
  async undoDeleteCheckDeposit({ commit }, payload) {
    await apiClient
      .route(DeleteCheckDepositController.undo.get({ id: payload.id }))
      .then(async (response) => {
        await commit('setCheckDepositList', response.data.check_deposits)
        await commit('setCheckMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('undoDeleteCheckDeposit', reason)
      })
  }
  //endregion
}
